import navbar from "@src/redux/navbar";
import layout from "@src/redux/layout";
import auth from "@src/redux/authentication";
import app from "@src/redux/app";
import users from "@src/views/user/store";
import {lazy} from "react";
// Populate the task detail registry before the /tasks/:task_id route renders.
import "./taskDetailRegistrations";
import {
    G, allow, ALL_COMMISSION_ROLES, ALL_PROFILES,
    ADMIN_SUPPORT, ADMIN_HSE,
    ADMIN_SETUP, PQ_ACCESS, PQ_ADMIN
} from "./permissions";
import {
    Activity,
    Archive,
    AtSign,
    Award,
    Book,
    BookOpen,
    Briefcase,
    Calendar,
    CheckSquare,
    Circle,
    Clipboard,
    Clock,
    Command,
    Copy,
    File,
    Folder,
    Grid,
    HelpCircle,
    Home,
    Layers,
    Mail,
    Server,
    Settings,
    Tool,
    Printer,
    TrendingUp,
    User,
    Users,
    Layout
} from 'react-feather';


const backendBasePath = process.env.REACT_APP_HOST_API

// This file holds the common configuration for the application:
// 1. Auth configuraiton : JWT olympus authentication
// 2. API endpoints
// 3. Olympus reducers
// 4. Routing System endpoints

export default {
    auth: {
        basePath: `${backendBasePath}auth`,
        loginEndpoint: `${backendBasePath}auth/initiate_auth`,
        registerEndpoint: `${backendBasePath}auth/account/registration`,
        refreshEndpoint: `${backendBasePath}auth/refresh_auth`,
        logoutEndpoint: `${backendBasePath}auth/logout`,
        tokenType: "Bearer",
        storageTokenKeyName: "accessToken",
        storageRefreshTokenKeyName: "refreshToken",
        storageIdTokenKeyName: "idToken",
        sendVerificationEmailEndpoint: `${backendBasePath}auth/account/email-verification/send-email`,
        verifyEmailEndpoint: `${backendBasePath}auth/account/email-verification`,
        activationAccountEndpoint: `${backendBasePath}auth/account/activation/send-email`,
        forgotPasswordEndpoint: `${backendBasePath}auth/password/forgot`,
        challengeEndpoint: `${backendBasePath}auth/respond_to_challenge`,
        changePasswordEndpoint: `${backendBasePath}auth/password/reset`,
        changeTempPasswordEndpoint: `${backendBasePath}auth/password/change`
    },
    API: {
        base: `${backendBasePath}`,
        assets: `${backendBasePath}assets`,
        usersAPI: `${backendBasePath}users`,
        plants: `${backendBasePath}assets/plants`,
        base_packages: `${backendBasePath}assets/base_packages`,
        processes: `${backendBasePath}assets/processes`,
        countries: `${backendBasePath}not-used`,
        contracts: `${backendBasePath}assets/contracts`,
        contractTypes: `${backendBasePath}assets/contract_types`,
        customers: `${backendBasePath}assets/customers`,
        groups: `${backendBasePath}assets/plant_groups`,
        groups_supervisor: `${backendBasePath}assets/plant_groups_supervisor`,
        inspection_reports: `${backendBasePath}assets/inspection_reports`,
        mainteiners: `${backendBasePath}assets/technicians`,
        submit_reports: `${backendBasePath}planning/maintenances`,
        companies: `${backendBasePath}assets/companies`,
        dashboard231: `${backendBasePath}model231/dashboard`,
        company231: `${backendBasePath}model231/companies`,
        checklist231: `${backendBasePath}model231/checklists`,
        public231: `${backendBasePath}model231/public/invitation`,
        planners: `${backendBasePath}assets/planners`,
        reports: `${backendBasePath}assets/report_types`,
        section_reports: `${backendBasePath}assets/report_sections`,
        activities: `${backendBasePath}assets/activities`,
        maintenances: `${backendBasePath}planning/maintenances`,
        maintenanceType: `${backendBasePath}assets/maintenance_types`,
        workorders: `${backendBasePath}assets/workorders`,
        planning: `${backendBasePath}planning`,
        availability: `${backendBasePath}availability`,
        customer: `${backendBasePath}public/maintenances`,
        hse_docs_categories: `${backendBasePath}hse_docs_categories`,
        hse_docs: `${backendBasePath}hse_docs`,
        hse_roles: `${backendBasePath}hse_roles`,
        kaleyra: `${backendBasePath}kaleyra`,
        comunication_groups: `${backendBasePath}communication_recipient_groups`,
        comunications: `${backendBasePath}communications`,
        comunication_types: `${backendBasePath}communication_types`,
        dashboard: `${backendBasePath}dashboard`,
        KPI: `${backendBasePath}kpis`,
        mobile_app: `${backendBasePath}mobile_app`,
        aiPath: `${backendBasePath}ai`,
        proposals: `${backendBasePath}proposals`,
        team: `${backendBasePath}assets/maintenance_teams`,
        commissions: `${backendBasePath}commissions`,
        commissionExtraFields: `${backendBasePath}commission_extra_fields`,
        commissionExtraFieldCategories: `${backendBasePath}commission_extra_field_categories`,
        commissionsDocCategories: `${backendBasePath}commission_doc_category`,
        commissionsDocScope: `${backendBasePath}commission_doc_scope`,
        commissionAttachmentTypes: `${backendBasePath}commission_attachment_types`,
        commissionsStatuses: `${backendBasePath}commission_statuses`,
        assignment_committees: `${backendBasePath}committees`,
        risk_analysis: `${backendBasePath}risk_analysis`,
        locations: `${backendBasePath}locations`,
        plant_clusters: `${backendBasePath}assets/plant_clusters`,
        commission_flow_templates: `${backendBasePath}commission_flow_templates`,
        hazard_reports: `${backendBasePath}hazard_reports`,
        tasks: `${backendBasePath}tasks`,
        LMS: `${backendBasePath}lms/admin`,
        LMSUser: `${backendBasePath}lms/student`,
        hse_analytics: `${backendBasePath}dashboard/hse_analytics`,
        ODLTypes: `${backendBasePath}odl_types`,
        meetingTypes: `${backendBasePath}meeting_types`,
        meetingCategories: `${backendBasePath}meeting_categories`,
        equipments: `${backendBasePath}equipments`,
        documents: `${backendBasePath}document`,
        company_equipment: `${backendBasePath}company_equipment`,
        company_equipments_view : `${backendBasePath}equipment`,
        equipment_docs_categories: `${backendBasePath}equipment_docs_categories`,
        company_equipment_assignments: `${backendBasePath}assignment`,
        partnerQualification: `${backendBasePath}partner_qualification`,
        partnerQualificationPublic: `${backendBasePath}partner_qualification/public`,
        partnerQualificationContractPublic: `${backendBasePath}partner_qualification/public/contract`,
        sign: `${backendBasePath}sign`,
        helpCenter: `${backendBasePath}help_center/admin`,
        helpCenterUser: `${backendBasePath}help_center`,
        partnerEvaluations: `${backendBasePath}partner_evaluations`,
        partnerEvaluationTypes: `${backendBasePath}partner_evaluation_types`
    },
    reduxReducers: {
        auth,
        app,
        users,
        navbar,
        layout
    },
    routing: {
        routes: [
            {
                path: "/maintenance",
                component: lazy(() => import("../hermes/maintenance_page/MaintenancePage")),
                layout: "BlankLayout",
                meta: {
                    publicRoute: true
                }
            },
            {
                path: "/portal/qualification/:token/compile",
                component: lazy(() => import("../hermes/partner_portal/PortalShell")),
                layout: "BlankLayout",
                meta: {
                    publicRoute: true
                }
            },
            {
                path: "/portal/contract/:token/upload",
                component: lazy(() => import("../hermes/contract_portal/ContractUploadShell")),
                layout: "BlankLayout",
                meta: {
                    publicRoute: true
                }
            },
            {
                path: "/portal/contract/:token",
                component: lazy(() => import("../hermes/contract_portal/OtpGate")),
                layout: "BlankLayout",
                meta: {
                    publicRoute: true
                }
            },
            {
                path: "/portal/qualification/:token",
                component: lazy(() => import("../hermes/partner_portal/OtpGate")),
                layout: "BlankLayout",
                meta: {
                    publicRoute: true
                }
            },
            {
                path: "/sso",
                component: lazy(() => import("../hermes/sso/SSORedirect")),
                layout: "BlankLayout",
                meta: {
                    publicRoute: true
                }
            },
            {
                path: "/lms/user/challenge/:challengeId/quizzes/:quizId",
                component: lazy(() => import("../hermes/lms/user/enrollments/user_quizz")),
                layout: "BlankLayout",
                meta: allow(ALL_PROFILES.filter(g => g !== G.SUPPORT))
            },
            {
                path: "/lms/user/challenges/:id",
                layout: "BlankLayout",
                component: lazy(() => import("../hermes/lms/user/enrollments/user_challenge")),
                meta: allow(...ALL_PROFILES)
            },
            {
                path: "/lms/user/enrollments/:id",
                layout: "BlankLayout",
                component: lazy(() => import("../hermes/lms/user/enrollments/user_course")),
                meta: allow(...ALL_PROFILES)
            },
            {
                path: "/lms/user/enrollments",
                layout: "BlankLayout",
                component: lazy(() => import("../hermes/lms/user/enrollments/user_enrolls")),
                meta: allow(...ALL_PROFILES)
            },
            {
                path: "/hse_models/commission_extra_fields",
                component: lazy(() => import("../hermes/commissions/extra_fields/index")),
                meta: allow(G.SUPPORT, G.C_B2B, G.C_PM, G.C_PM_HSE, G.C_PROCURATOR_LEV1, G.C_PROCURATOR_LEV2)
            },
            {
                path: "/lms/courses/view/:id",
                component: lazy(() => import("../hermes/lms/admin/courses/view")),
                meta: allow(...ADMIN_SUPPORT)
            },
            {
                path: "/lms/courses/new",
                component: lazy(() => import("../hermes/lms/admin/courses/new")),
                meta: allow(G.ADMIN)
            },
            {
                path: "/lms/courses",
                component: lazy(() => import("../hermes/lms/admin/courses/list")),
                meta: allow(...ADMIN_SUPPORT)
            },
            // ---- Help Center / DAP (issue #164) ----
            {
                // editor nuovo contenuto: scrittura -> solo SUPPORT
                path: "/help-center/admin/contents/new",
                component: lazy(() => import("../hermes/help_center/admin/ContentEditor")),
                meta: allow(G.SUPPORT)
            },
            {
                // editor contenuto esistente: visibile anche ad ADMINISTRATOR (sola lettura lato API)
                path: "/help-center/admin/contents/:id",
                component: lazy(() => import("../hermes/help_center/admin/ContentEditor")),
                meta: allow(...ADMIN_SUPPORT)
            },
            {
                // gestione contenuti (backoffice): SUPPORT (scrittura) + ADMINISTRATOR (lettura)
                path: "/help-center/admin",
                component: lazy(() => import("../hermes/help_center/admin/ContentManager")),
                meta: allow(...ADMIN_SUPPORT)
            },
            {
                // pagina categoria (alberatura globale + lettore inline): tutti gli utenti autenticati
                path: "/help-center/categories/:slug",
                component: lazy(() => import("../hermes/help_center/consumer/CategoryView")),
                meta: allow(ALL_PROFILES.filter(g => ![G.TECHNICIAN].includes(g)))
            },
            {
                // fruizione articolo (stesso layout tree + lettore della pagina categoria)
                path: "/help-center/articles/:slug",
                component: lazy(() => import("../hermes/help_center/consumer/CategoryView")),
                meta: allow(ALL_PROFILES.filter(g => ![G.TECHNICIAN].includes(g)))
            },
            {
                // home help center (knowledge base): tutti gli utenti autenticati
                path: "/help-center",
                component: lazy(() => import("../hermes/help_center/consumer/HelpCenterHome")),
                meta: allow(ALL_PROFILES.filter(g => ![G.TECHNICIAN].includes(g)))
            },
            {
                path: "/lms/prizes/view/:id",
                component: lazy(() => import("../hermes/lms/admin/prizes/view")),
                meta: allow(...ADMIN_SUPPORT)
            },
            {
                path: "/lms/prizes/new",
                component: lazy(() => import("../hermes/lms/admin/prizes/new")),
                meta: allow(G.ADMIN)
            },
            {
                path: "/lms/prizes",
                component: lazy(() => import("../hermes/lms/admin/prizes/list")),
                meta: allow(...ADMIN_SUPPORT)
            },
            {
                path: "/lms/quizzes/view/:id",
                component: lazy(() => import("../hermes/lms/admin/quizzes/view")),
                meta: allow(...ADMIN_SUPPORT)
            },
            {
                path: "/lms/quizzes/new",
                component: lazy(() => import("../hermes/lms/admin/quizzes/new")),
                meta: allow(G.ADMIN)
            },
            {
                path: "/lms/quizzes",
                component: lazy(() => import("../hermes/lms/admin/quizzes/list")),
                meta: allow(...ADMIN_SUPPORT)
            },
            {
                path: "/lms/challenges/dashboard/:id",
                component: lazy(() => import("../hermes/lms/admin/challenges/dashboard")),
                meta: allow(...ADMIN_SUPPORT)
            },
            {
                path: "/lms/challenges/view/:id",
                component: lazy(() => import("../hermes/lms/admin/challenges/view")),
                meta: allow(...ADMIN_SUPPORT)
            },
            {
                path: "/lms/challenges/new",
                component: lazy(() => import("../hermes/lms/admin/challenges/new")),
                meta: allow(G.ADMIN)
            },
            {
                path: "/lms/challenges",
                component: lazy(() => import("../hermes/lms/admin/challenges/list")),
                meta: allow(...ADMIN_SUPPORT)
            },
            {
                path: "/meeting_types",
                component: lazy(() => import("../hermes/commissions/meetings/types")),
                meta: allow(G.SUPPORT, G.C_B2B, G.C_PM, G.C_PM_HSE, G.C_PROCURATOR_LEV1, G.C_PROCURATOR_LEV2)
            },
            {
                path: "/commissions/:commission_id/meetings/:meeting_id",
                component: lazy(() => import("../hermes/commissions/meetings/externalMeetingPage")),
                layout: "BlankLayout",
                meta: { publicRoute: true }
            },
            {
                path: "/tasks/:task_id",
                component: lazy(() => import("../hermes/tasks/TaskDetailPage")),
                meta: allow(ALL_PROFILES.filter(g => g !== G.TECHNICIAN))
            },
            {
                path: "/commission_flows_mngmt",
                component: lazy(() => import("../hermes/commissions/commissions_gantt")),
                meta: allow(G.SUPPORT, G.C_B2B, G.C_LOGISTICIAN, G.C_PROSAT, G.C_OFFERING, G.C_PROCURATOR_LEV1, G.C_PROCURATOR_LEV2)
            },
            {
                path: "/ai",
                component: lazy(() => import("../hermes/ai")),
                meta: allow(G.ADMIN)
            },
            {
                path: "/checklist_validation/:id",
                component: lazy(() => import("../hermes/231/checklist/index")),
                meta: allow(G.VALIDATOR_231)
            },
            {
                path: "/reports",
                component: lazy(() => import("../hermes/report/report")),
                meta: allow(G.ADMIN, G.BACKOFFICE, G.HSE_MGR, G.ACTIVITY_SUPERVISOR, G.MANAGER, G.SUPPORT, G.HSE_SUPERVISOR)
            },
            {
                path: "/report_validation",
                component: lazy(() => import("../hermes/report/report_validation")),
                meta: allow(G.ADMIN, G.ACTIVITY_SUPERVISOR, G.BACKOFFICE, G.SUPPORT)
            },
            {
                path: "/contracts",
                component: lazy(() => import("../hermes/anagrafica/contracts/list")),
                meta: allow(G.ADMIN, G.HSE_MGR, G.ACTIVITY_SUPERVISOR, G.SUPPORT, G.HSE_SUPERVISOR)
            },
            {
                path: "/customers",
                component: lazy(() => import("../hermes/anagrafica/customers/list")),
                meta: allow(G.ADMIN, G.ACTIVITY_SUPERVISOR)
            },
            {
                path: "/kpi_management",
                component: lazy(() => import("../hermes/kpi_management/kpi_phases")),
                meta: allow(G.ADMIN, G.ACTIVITY_SUPERVISOR, G.SUPPORT)
            },
            {
                path: "/dashboard",
                component: lazy(() => import("../hermes/dashboard")),
                meta: allow(G.PLANNER, G.ADMIN, G.ACTIVITY_SUPERVISOR, G.SUPPORT)
            },
            {
                path: "/qualification-dashboard",
                component: lazy(() => import("../hermes/home/QualificationManagerDashboard")),
                meta: allow(G.Q_MANAGER)
            },
            {
                path: "/dashboard_checkin",
                component: lazy(() => import("../hermes/dashboard/dashboard_checkin")),
                meta: allow(...ADMIN_HSE)
            },
            {
                path: "/dashboard_hse_analytics",
                component: lazy(() => import("../hermes/dashboard/hse/list")),
                meta: allow(...ADMIN_HSE)
            },
            {
                path: "/agenda/cancelled_maintenances/:agenda_date/:agenda_id",
                component: lazy(() => import("../hermes/agenda/cancelledMaintenanceView")),
                meta: allow(G.PLANNER, G.ADMIN, G.HSE_MGR, G.MANAGER, G.SUPPORT, G.HSE_SUPERVISOR)
            },
            {
                path: "/agenda",
                component: lazy(() => import("../hermes/agenda")),
                meta: allow(G.PLANNER, G.ADMIN, G.HSE_MGR, G.ACTIVITY_SUPERVISOR, G.MANAGER, G.SUPPORT, G.HSE_SUPERVISOR)
            },
            {
                path: "/activities/view/:id",
                component: lazy(() => import("../hermes/activities/view")),
                meta: allow(G.PLANNER, G.ADMIN, G.BACKOFFICE, G.HSE_MGR, G.LOGISTICIAN, G.ACTIVITY_SUPERVISOR, G.MANAGER, G.SUPPORT, G.HSE_SUPERVISOR)
            },
            {
                path: "/activities",
                component: lazy(() => import("../hermes/activities/list")),
                meta: allow(G.PLANNER, G.ADMIN, G.BACKOFFICE, G.LOGISTICIAN, G.ACTIVITY_SUPERVISOR, G.MANAGER, G.SUPPORT)
            },
            {
                path: "/processes",
                component: lazy(() => import("../hermes/anagrafica/processes/list")),
                meta: allow(...ADMIN_SUPPORT)
            },
            {
                path: "/maintenances/:id/plants_view/:plantId",
                component: lazy(() => import("../hermes/maintenance/maintenance_view")),
                meta: allow(G.PLANNER, G.ADMIN, G.HSE_MGR, G.ACTIVITY_SUPERVISOR, G.MANAGER, G.SUPPORT, G.HSE_SUPERVISOR)
            },
            {
                path: "/inspections/:id/download_report",
                component: lazy(() => import("../hermes/anagrafica/inspections/downloadReportPage")),
                layout: "BlankLayout",
                meta: allow(G.ADMIN, G.ACTIVITY_SUPERVISOR, G.HSE_SUPERVISOR, G.SUPPORT, G.MANAGER, G.HSE_MGR, G.BACKOFFICE)
            },
            {
                path: "/inspections",
                component: lazy(() => import("../hermes/anagrafica/inspections/list")),
                meta: allow(G.ADMIN, G.ACTIVITY_SUPERVISOR, G.SUPPORT, G.MANAGER, G.HSE_MGR, G.HSE_SUPERVISOR)
            },
            {
                path: "/maintenances",
                component: lazy(() => import("../hermes/maintenance/list")
                    .then(mod => ({default: mod.MaintenanceList}))),
                meta: allow(G.PLANNER, G.ADMIN, G.BACKOFFICE, G.HSE_MGR, G.ACTIVITY_SUPERVISOR, G.MANAGER, G.SUPPORT, G.HSE_SUPERVISOR)
            },
            {
                path: "/comunications/view/:id",
                component: lazy(() => import("../hermes/comunication/view")),
                meta: allow(ALL_PROFILES.filter(g => g !== G.TECHNICIAN))
            },
            {
                path: "/comunications/new",
                component: lazy(() => import("../hermes/comunication/new")),
                meta: allow(G.ADMIN, G.HSE_MGR, G.HSE_SUPERVISOR)
            },
            {
                path: "/comunication_groups/new",
                component: lazy(() => import("../hermes/comunication/groups/new")),
                meta: allow(G.ADMIN)
            },
            {
                path: "/comunication_groups/view/:id",
                component: lazy(() => import("../hermes/comunication/groups/edit")),
                meta: allow(...ADMIN_HSE)
            },
            {
                path: "/comunication_groups",
                component: lazy(() => import("../hermes/comunication/groups/index")),
                meta: allow(...ADMIN_HSE)
            },
            {
                path: "/comunications",
                component: lazy(() => import("../hermes/comunication/index")),
                meta: allow(ALL_PROFILES.filter(g => g !== G.TECHNICIAN))
            },
            {
                path: "/comunication_types/view/:id",
                component: lazy(() => import("../hermes/comunication/types/view")),
                meta: allow(...ADMIN_HSE)
            },
            {
                path: "/comunication_types/new",
                component: lazy(() => import("../hermes/comunication/types/new")),
                meta: allow(G.ADMIN)
            },
            {
                path: "/comunication_types",
                component: lazy(() => import("../hermes/comunication/types/index")),
                meta: allow(...ADMIN_HSE)
            },
            {
                path: "/workorders",
                component: lazy(() => import("../hermes/anagrafica/workorders/list")),
                meta: allow(...ADMIN_SUPPORT)
            },
            {
                path: "/attendance",
                component: lazy(() => import("../hermes/attendance")),
                meta: allow(G.PLANNER, G.BACKOFFICE, G.SUPPORT)
            },
            {
                path: "/downloadapp",
                component: lazy(() => import("../hermes/app")),
                layout: "BlankLayout",
                meta: allow(G.TECHNICIAN, G.ADMIN, G.ACTIVITY_SUPERVISOR, G.HSE_SUPERVISOR, G.SUPPORT)
            },
            {
                path: "/home",
                component: lazy(() => import("../hermes/home")),
                meta: allow(...ALL_PROFILES)
            },
            {
                path: "/company_configuration",
                component: lazy(() => import("../hermes/anagrafica/companies/configuration/index")),
                meta: allow(G.ADMIN, G.BACKOFFICE, G.SUPPORT)
            },
            {
                path: "/plants/view/:id",
                component: lazy(() => import("../hermes/anagrafica/plants/view")),
                meta: allow(G.PLANNER, G.ADMIN, G.BACKOFFICE, G.HSE_MGR, G.LOGISTICIAN, G.ACTIVITY_SUPERVISOR, G.MANAGER, G.SUPPORT, G.HSE_SUPERVISOR)
            },
            {
                path: "/plants",
                component: lazy(() => import("../hermes/anagrafica/plants/list")),
                meta: allow(G.PLANNER, G.ADMIN, G.BACKOFFICE, G.HSE_MGR, G.LOGISTICIAN, G.ACTIVITY_SUPERVISOR, G.MANAGER, G.SUPPORT, G.HSE_SUPERVISOR)
            },
            {
                path: "/report_types/view/:key",
                component: lazy(() => import("../hermes/anagrafica/reports/edit")),
                meta: allow(...ADMIN_SUPPORT)
            },
            {
                path: "/report_types/new",
                component: lazy(() => import("../hermes/anagrafica/reports/new")),
                meta: allow(G.ADMIN)
            },
            {
                path: "/report_types",
                component: lazy(() => import("../hermes/anagrafica/reports/list")),
                meta: allow(...ADMIN_SUPPORT)
            },
            {
                path: "/groups/view/:id",
                component: lazy(() => import("../hermes/anagrafica/groups/view")),
                meta: allow(...ADMIN_SUPPORT)
            },
            {
                path: "/groups/add",
                component: lazy(() => import("../hermes/anagrafica/groups/add")),
                meta: allow(G.ADMIN)
            },
            {
                path: "/groups",
                component: lazy(() => import("../hermes/anagrafica/groups/list")),
                meta: allow(...ADMIN_SUPPORT)
            },
            {
                path: "/supervisor_groups/view/:id",
                component: lazy(() => import("../hermes/anagrafica/supervisor_groups/view")),
                meta: allow(...ADMIN_SUPPORT)
            },
            {
                path: "/supervisor_groups/add",
                component: lazy(() => import("../hermes/anagrafica/supervisor_groups/add")),
                meta: allow(G.ADMIN)
            },
            {
                path: "/supervisor_groups",
                component: lazy(() => import("../hermes/anagrafica/supervisor_groups/list")),
                meta: allow(...ADMIN_SUPPORT)
            },
            {
                path: "/companies231/view/:id",
                component: lazy(() => import("../hermes/231/companies/view")),
                meta: allow(G.VALIDATOR_231, G.MANAGER_231)
            },
            {
                path: "/companies231/new",
                component: lazy(() => import("../hermes/231/companies/new")),
                meta: allow(G.MANAGER_231)
            },
            {
                path: "/companies231",
                component: lazy(() => import("../hermes/231/companies/list")),
                meta: allow(G.VALIDATOR_231, G.MANAGER_231)
            },
            {
                path: "/companies/view/:id",
                component: lazy(() => import("../hermes/anagrafica/companies/view")),
                meta: allow(G.ADMIN, G.BACKOFFICE, G.HSE_MGR, G.SUPPORT, G.HSE_SUPERVISOR, G.C_PROCURATOR_LEV1, G.C_PROCURATOR_LEV2, G.C_B2B, G.C_PM, G.C_PM_HSE)
            },
            {
                path: "/companies",
                component: lazy(() => import("../hermes/anagrafica/companies/list")),
                meta: allow(G.ADMIN, G.BACKOFFICE, G.HSE_MGR, G.SUPPORT, G.HSE_SUPERVISOR, G.C_PROCURATOR_LEV1, G.C_PROCURATOR_LEV2, G.C_B2B, G.C_PM, G.C_PM_HSE)
            },
            // ** Hiding odl types management for the moment, DB-First
            // {
            //     path: "/odl_types",
            //     component: lazy(() => import("../hermes/anagrafica/odl_types")),
            //     meta: {
            //         administrator: true,
            //         "commission-b2b-coordinator": true,
            //         "support": true,
            //         "commission-pm": true
            //     }
            // },
            // {
            //     path: "/companies/add",
            //     component: lazy(() => import("../hermes/anagrafica/companies/add")),
            //     meta: {
            //         publicRoute: false,
            //         technician: false,
            //         planner: false,
            //         administrator: true,
            //         "backoffice-manager": false,
            //         "hse-manager": false,
            //         logistician: false
            //     },
            // },
            {
                path: "/hse_models/user",
                component: lazy(() => import("../hermes/anagrafica/hse_docs/user_hse_models_view")),
                meta: allow(...ADMIN_HSE)
            },
            {
                path: "/hse_models/company",
                component: lazy(() => import("../hermes/anagrafica/hse_docs/company_hse_models_view")),
                meta: allow(...ADMIN_HSE)
            },
            {
                path: "/hse_models/equipment_hse_models",
                component: lazy(() => import("../hermes/anagrafica/equipments/documents/view")),
                meta: allow(...ADMIN_HSE)
            },
            {
                path: "/hse_models/commission",
                component: lazy(() => import("../hermes/anagrafica/hse_docs/commission_models_view")),
                meta: allow(G.SUPPORT, G.C_B2B, G.C_PM, G.C_PM_HSE, G.C_PROCURATOR_LEV1, G.C_PROCURATOR_LEV2)
            },
            {
                path: "/hse_models/hse_roles",
                component: lazy(() => import("../hermes/anagrafica/hse_docs/hse_roles/hse_roles_view")),
                meta: allow(...ADMIN_HSE)
            },
            {
                path: "/hse_models/user_maintenance_types",
                component: lazy(() => import("../hermes/anagrafica/hse_docs/maintenance_types/view")),
                meta: allow(...ADMIN_HSE)
            },
            {
                path: "/hse_models/base_packages",
                component: lazy(() => import("../hermes/anagrafica/hse_docs/base_packages/view")),
                meta: allow(...ADMIN_HSE)
            },
            {
                path: "/hse_models/company_legal_forms",
                component: lazy(() => import("../hermes/anagrafica/hse_docs/company_legal_forms/view")),
                meta: allow(...ADMIN_HSE)
            },
            {
                path: "/hse_models/equipment_types",
                component: lazy(() => import("../hermes/anagrafica/equipments/equipment_models/view")),
                meta: allow(...ADMIN_HSE)
            },
            {
                path: "/plant_hse_docs",
                component: lazy(() => import("../hermes/anagrafica/plants/plant_hse_docs")),
                meta: allow(...ADMIN_HSE)
            },
            {
                path: "/maintenance_hse_docs",
                component: lazy(() => import("../hermes/maintenance/hse_docs/maintenance_hse_docs")),
                meta: allow(...ADMIN_HSE)
            },
            {
                path: "/proposals/view/:id",
                component: lazy(() => import("../hermes/anagrafica/proposals/view")),
                meta: allow(G.ADMIN, G.MOBILE_WORKER, G.COMMERCIAL, G.MARKETING, G.SUPPORT)
            },
            {
                path: "/proposals",
                component: lazy(() => import("../hermes/anagrafica/proposals/list")),
                meta: allow(G.ADMIN, G.DATA_ANALYST, G.MOBILE_WORKER, G.COMMERCIAL, G.MARKETING, G.SUPPORT)
            },
            {
                path: "/commissions/sals",
                component: lazy(() => import("../hermes/commissions/sal/SalApprovalsPage")),
                meta: allow(G.SUPPORT, G.DATA_ANALYST, G.C_B2B, G.C_PM, G.C_PM_HSE, G.C_LOGISTICIAN, G.C_PROSAT, G.C_OFFERING, G.C_PARTNER, G.C_PROCURATOR_LEV1, G.C_PROCURATOR_LEV2)
            },
            {
                path: "/commissions/details/:id",
                component: lazy(() => import("../hermes/commissions/view")),
                meta: allow(G.SUPPORT, ...ALL_COMMISSION_ROLES)
            },
            {
                path: "/commissions/new",
                component: lazy(() => import("../hermes/commissions/view")),
                meta: allow(G.SUPPORT, G.C_B2B, G.C_PROCURATOR_LEV1, G.C_PROCURATOR_LEV2)
            },
            {
                path: "/commissions",
                component: lazy(() => import("../hermes/commissions/list")),
                meta: allow(G.SUPPORT, G.DATA_ANALYST, ...ALL_COMMISSION_ROLES)
            },
            {
                path: "/odls",
                component: lazy(() => import("../hermes/commissions/odl/ODLPage")),
                meta: allow(G.SUPPORT, G.DATA_ANALYST, G.C_B2B, G.C_PROCURATOR_LEV1, G.C_PROCURATOR_LEV2, G.C_LOGISTICIAN, G.C_PM, G.C_PM_HSE, G.C_PARTNER, G.C_PROSAT, G.C_OFFERING)
            },
            {
                path: "/commission_statuses",
                component: lazy(() => import("../hermes/commissions/status")),
                meta: allow(G.SUPPORT, G.C_B2B, G.C_PM, G.C_PM_HSE, G.C_PROCURATOR_LEV1, G.C_PROCURATOR_LEV2)
            },
            {
                path: "/assignment_committees/details/:id",
                component: lazy(() => import("../hermes/assignment_committees/view")),
                meta: allow(G.SUPPORT, G.C_B2B, G.C_PROCURATOR_LEV1, G.C_PROCURATOR_LEV2)
            },
            {
                path: "/assignment_committees/new",
                component: lazy(() => import("../hermes/assignment_committees/view")),
                meta: allow(G.C_B2B)
            },
            {
                path: "/assignment_committees",
                component: lazy(() => import("../hermes/assignment_committees/index")),
                meta: allow(G.SUPPORT, G.C_B2B, G.C_PROCURATOR_LEV1, G.C_PROCURATOR_LEV2)
            },
            {
                path: "/commission_flow_templates/details/:templateKey",
                component: lazy(() => import("../hermes/commissions/template_flow/view")),
                meta: allow(G.SUPPORT, G.C_B2B, G.C_PM, G.C_PM_HSE, G.C_PROCURATOR_LEV1, G.C_PROCURATOR_LEV2)
            },
            {
                path: "/commission_flow_templates/new",
                component: lazy(() => import("../hermes/commissions/template_flow/view")),
                meta: allow(G.C_B2B, G.C_PROCURATOR_LEV1, G.C_PROCURATOR_LEV2)
            },
            {
                path: "/commission_flow_templates",
                component: lazy(() => import("../hermes/commissions/template_flow/index")),
                meta: allow(G.SUPPORT, G.C_B2B, G.C_PM, G.C_PM_HSE, G.C_PROCURATOR_LEV1, G.C_PROCURATOR_LEV2)
            },
            {
                path: "/login",
                component: lazy(() => import("@src/views/Login")),
                layout: "BlankLayout",
                meta: {
                    authRoute: true,
                },
            },
            {
                path: "/logout",
                component: lazy(() => import("@src/views/Logout")),
                layout: "BlankLayout",
                meta: {
                    authRoute: true,
                },
            },
            {
                path: "/error",
                component: lazy(() => import("@src/views/Error")),
                layout: "BlankLayout",
                meta: {
                    publicRoute: true,
                },
            },
            {
                path: "/must-change-password",
                component: lazy(() => import("olympus-frontend/src/views/MustChangePassword")),
                layout: "BlankLayout",
                meta: {
                    publicRoute: true
                }
            },
            {
                path: "/verify-otp",
                component: lazy(() => import("olympus-frontend/src/views/VerifyOTP")),
                layout: "BlankLayout",
                meta: {
                    authRoute: true,
                },
            },
            // ** Only internal view, must have meta **/
            {
                path: "/change-password",
                component: lazy(() => import("olympus-frontend/src/views/ChangePassword")),
                layout: "BlankLayout",
                meta: allow(...ALL_PROFILES)
            },
            {
                path: "/forgot-password",
                component: lazy(() => import("@src/views/ForgotPassword")),
                layout: "BlankLayout",
                meta: {
                    authRoute: true,
                },
            },
            {
                path: "/reset-password",
                component: lazy(() => import("@src/views/ResetPasswordBasic")),
                layout: "BlankLayout",
                meta: {
                    authRoute: true,
                },
            },
            {
                path: "/send-email-verification",
                component: lazy(() => import("@src/views/VerifyEmailBasic")),
                layout: "BlankLayout",
                meta: {
                    authRoute: true,
                },
            },
            {
                path: "/verify-email/:token",
                component: lazy(() => import("@src/views/VerificationEmailLanding")),
                layout: "BlankLayout",
                meta: {
                    authRoute: true,
                },
            },
            {
                path: "/polling-activation",
                component: lazy(() => import("@src/views/PollingActivation")),
                layout: "BlankLayout",
                meta: {
                    authRoute: true,
                },
            },
            {
                path: "/tasks",
                component: lazy(() => import("../hermes/anagrafica/users/taskboard")),
                meta: allow(ALL_PROFILES.filter((g) => g !== G.TECHNICIAN))
            },
            {
                path: "/company_equipment/view/:id",
                component: lazy(() => import("../hermes/anagrafica/equipments/equipment_company/view")),
                meta: allow(G.ADMIN, G.BACKOFFICE, G.HSE_MGR, G.SUPPORT, G.HSE_SUPERVISOR)
            },
            {
                path: "/users/view/:id",
                component: lazy(() => import("../hermes/anagrafica/users/view")),
                meta: allow(G.ADMIN, G.BACKOFFICE, G.HSE_MGR, G.SUPPORT, G.HSE_SUPERVISOR, G.C_PROCURATOR_LEV1, G.C_PROCURATOR_LEV2, G.C_B2B, G.C_PM, G.C_PM_HSE)
            },
            {
                path: "/users",
                component: lazy(() => import("../hermes/anagrafica/users/list")),
                meta: allow(G.ADMIN, G.BACKOFFICE, G.HSE_MGR, G.SUPPORT, G.HSE_SUPERVISOR, G.C_PROCURATOR_LEV1, G.C_PROCURATOR_LEV2, G.C_B2B, G.C_PM, G.C_PM_HSE)
            },
            {
                path: "/appointment_verification/:code",
                component: lazy(() => import("../hermes/appointment/verifyPage")),
                layout: "BlankLayout",
                meta: {
                    publicRoute: true
                },
            },
            {
                path: "/checklist_verification/:id",
                component: lazy(() => import("../hermes/231/public/verifyPage")),
                layout: "BlankLayout",
                meta: {
                    publicRoute: true
                },
            },
            {
                path: "/checklist/:id",
                component: lazy(() => import("../hermes/231/public/index")),
                layout: "BlankLayout",
                meta: {
                    publicRoute: true
                }
            },
            {
                path: "/app/f/:code",
                component: lazy(() => import("../hermes/appointment/checkin/feedback")),
                layout: "BlankLayout",
                meta: {
                    publicRoute: true
                }
            },
            {
                path: "/app/checkin/:code",
                component: lazy(() => import("../hermes/appointment/checkin")),
                layout: "BlankLayout",
                meta: {
                    publicRoute: true
                }
            },
            {
                path: "/app/:code",
                component: lazy(() => import("../hermes/appointment")),
                layout: "BlankLayout",
                meta: { publicRoute: true }
            },
            {
                path: "/feedback/:code",
                component: lazy(() => import("../hermes/appointment/feedback")),
                layout: "BlankLayout",
                meta: {
                    publicRoute: true
                }
            },
            {
                path: "/support",
                component: lazy(() => import("../hermes/supporto")),
                meta: allow(ALL_PROFILES.filter((g) => g !== G.TECHNICIAN))
            },
            // ── Partner Qualification ───────────────────────────
            {
                path: "/partner-qualification/iter/:id",
                component: lazy(() => import("../hermes/partner_qualification/iter/view")),
                meta: allow(...PQ_ACCESS)
            },
            {
                path: "/partner-qualification/iter",
                component: lazy(() => import("../hermes/partner_qualification/iter/list")),
                meta: allow(...PQ_ACCESS)
            },
            {
                // La rotta con segmento extra (`/validate`) DEVE precedere `/:id` (Switch non-exact),
                // altrimenti `/:id` la ombreggerebbe matchando solo il prefisso.
                path: "/partner-qualification/questionnaires/:id/validate",
                component: lazy(() => import("../hermes/partner_qualification/questionnaires/validate")),
                meta: allow(...PQ_ACCESS)
            },
            {
                path: "/partner-qualification/committees/new",
                component: lazy(() => import("../hermes/partner_qualification/committees/new")),
                meta: allow(...PQ_ADMIN)
            },
            {
                path: "/partner-qualification/committees/:id",
                component: lazy(() => import("../hermes/partner_qualification/committees/view")),
                meta: allow(...PQ_ACCESS)
            },
            {
                path: "/partner-qualification/committees",
                component: lazy(() => import("../hermes/partner_qualification/committees/list")),
                meta: allow(...PQ_ACCESS)
            },
            {
                path: "/partner-qualification/partners/:id",
                component: lazy(() => import("../hermes/partner_qualification/partners/view")),
                meta: allow(...PQ_ACCESS)
            },
            {
                path: "/partner-qualification/partners",
                component: lazy(() => import("../hermes/partner_qualification/partners/list")),
                meta: allow(...PQ_ACCESS)
            },
            {
                // DEVE precedere `/contracts` (Switch non-exact), che altrimenti matcherebbe il
                // prefisso e la scheda non verrebbe mai raggiunta.
                path: "/partner-qualification/contracts/:id",
                component: lazy(() => import("../hermes/partner_qualification/contracts/view")),
                meta: allow(...PQ_ACCESS)
            },
            {
                // PQ_ACCESS e non PQ_ADMIN: l'anagrafica contratti e' in sola lettura e la vede chi
                // vede la sezione iter, Q_OPERATOR compreso. Allineata ai profili dell'endpoint.
                path: "/partner-qualification/contracts",
                component: lazy(() => import("../hermes/partner_qualification/contracts/list")),
                meta: allow(...PQ_ACCESS)
            },
            {
                path: "/partner-qualification/settings/natures/new",
                component: lazy(() => import("../hermes/partner_qualification/natures/new")),
                meta: allow(...PQ_ADMIN)
            },
            {
                path: "/partner-qualification/settings/natures/:id",
                component: lazy(() => import("../hermes/partner_qualification/natures/view")),
                meta: allow(...PQ_ADMIN)
            },
            {
                path: "/partner-qualification/settings/natures",
                component: lazy(() => import("../hermes/partner_qualification/natures/list")),
                meta: allow(...PQ_ADMIN)
            },
            {
                path: "/partner-qualification/settings/categories",
                component: lazy(() => import("../hermes/partner_qualification/categories/list")),
                meta: allow(...PQ_ADMIN)
            },
            {
                path: "/partner-qualification/settings/requirements",
                component: lazy(() => import("../hermes/partner_qualification/requirements/list")),
                meta: allow(...PQ_ADMIN)
            },
            {
                path: "/partner-qualification/settings/due-diligence-type",
                component: lazy(() => import("../hermes/partner_qualification/due_diligence_type/list")),
                meta: allow(...PQ_ADMIN)
            },
            {
                path: "/partner-qualification/settings/questionnaires",
                component: lazy(() => import("../hermes/partner_qualification/matrix/MatrixEditor")),
                meta: allow(...PQ_ADMIN)
            },
            {
                path: "/partner-qualification/settings/document-templates",
                component: lazy(() => import("../hermes/partner_qualification/placeholder")),
                meta: allow(...PQ_ADMIN)
            },
            {
                path: "/partner-evaluations/settings/types",
                // Before /partner-evaluations/:id: otherwise "settings" would be read as the id
                component: lazy(() => import("../hermes/partner_evaluations/types/list")),
                // Catalog: configured by the qualification manager, read by admin, support and HSE
                meta: allow(...PQ_ADMIN, G.HSE_MGR, G.HSE_SUPERVISOR)
            },
            {
                path: "/partner-evaluations/:id",
                component: lazy(() => import("../hermes/partner_evaluations/view")),
                // Filling it in is a task: «Tasks» stays highlighted in the menu (isNavLinkActive reads meta.navLink)
                // Same profiles as the taskboard (/tasks): whoever sees the card of an
                // evaluation task must be able to open it — the BE still restricts
                // non-assignees outside the admin/support/HSE profiles
                meta: {...allow(ALL_PROFILES.filter(g => g !== G.TECHNICIAN), ALL_COMMISSION_ROLES), navLink: "/tasks"}
            },
            {
                path: "/partner-evaluations",
                component: lazy(() => import("../hermes/partner_evaluations/index")),
                meta: allow(...ADMIN_HSE, G.Q_MANAGER)
            }
        ],
        defaultRoute: "/home",
    },
    layout: {
        isRTL: false,
        skin: "light", // light, dark, bordered, semi-dark
        routerTransition: "fadeIn", // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
        type: "vertical", // vertical, horizontal
        contentWidth: "full", // full, boxed
        menu: {
            isHidden: false,
            isCollapsed: true,
        },
        navbar: {
            // ? For horizontal menu, navbar type will work for navMenu type
            type: "static", // static , sticky , floating, hidden
            backgroundColor: "", // BS color options [primary, success, etc]
        },
        footer: {
            type: "static", // static, sticky, hidden
        },
        customizer: false,
        navbarNavigation: [
            {
                header: 'Main',
                meta: allow(ALL_PROFILES.filter(g => g !== G.TECHNICIAN))
            },
            // TODO: BUTTON IS NOT VISIBLE
            // TODO: manage the home as a page!
            {
                id: "home",
                title: "Home",
                icon: <Home size={20}/>,
                navLink: "/home",
                meta: allow([])
            },
            // Qualification manager dashboard: its own page, /home redirects here
            {
                id: "qualification_dashboard",
                title: "Dashboard",
                icon: <Home size={20}/>,
                navLink: "/qualification-dashboard",
                meta: allow(G.Q_MANAGER)
            },
            {
                id: "dashboard",
                title: "Dashboard",
                icon: <Home size={20}/>,
                navLink: "/dashboard",
                meta: allow(G.PLANNER, G.ADMIN, G.ACTIVITY_SUPERVISOR, G.SUPPORT)
            },
            {
                id: "my_taskboard",
                title: "Tasks",
                badge: 'primary',
                badgeText: '',
                comunicationBadge: true,
                navLink: "/tasks",
                icon: <CheckSquare size={20}/>,
                meta: allow(ALL_PROFILES.filter(g => g !== G.TECHNICIAN))
            },
            {
                id: "engineering_costruction",
                title: "Construction B2B",
                navLink: "",
                icon: <Layers size={20}/>,
                meta: allow(G.SUPPORT, G.DATA_ANALYST, ...ALL_COMMISSION_ROLES),
                children: [
                    {
                        id: "committees",
                        title: "Committees",
                        icon: <Circle size={12}/>,
                        navLink: '/assignment_committees',
                        meta: allow(G.SUPPORT, G.C_B2B, G.C_PROCURATOR_LEV1, G.C_PROCURATOR_LEV2)
                    },
                    {
                        id: "commissions",
                        title: "Commissions",
                        icon: <Circle size={12}/>,
                        navLink: '/commissions',
                        meta: allow(G.SUPPORT, G.DATA_ANALYST, ...ALL_COMMISSION_ROLES)
                    },
                    {
                        id: "odls",
                        title: "ODL",
                        icon: <Circle size={12}/>,
                        navLink: '/odls',
                        meta: allow(G.SUPPORT, G.DATA_ANALYST, G.C_B2B, G.C_PROCURATOR_LEV1, G.C_PROCURATOR_LEV2, G.C_LOGISTICIAN, G.C_PM, G.C_PM_HSE, G.C_PARTNER, G.C_PROSAT, G.C_OFFERING)
                    },
                    {
                        id: "sal_approvals",
                        title: "SAL",
                        icon: <Circle size={12}/>,
                        navLink: '/commissions/sals',
                        meta: allow(G.SUPPORT, G.DATA_ANALYST, G.C_B2B, G.C_PM, G.C_PM_HSE, G.C_LOGISTICIAN, G.C_PROSAT, G.C_OFFERING, G.C_PARTNER, G.C_PROCURATOR_LEV1, G.C_PROCURATOR_LEV2)
                    },
                    {
                        id: "construction_setup",
                        title: "Setup",
                        navLink: "",
                        icon: <Circle size={12}/>,
                        meta: allow(G.SUPPORT, G.C_B2B, G.C_PM, G.C_PM_HSE, G.C_PROCURATOR_LEV1, G.C_PROCURATOR_LEV2),
                        children: [
                            {
                                id: "extra_fields",
                                title: "Data Entry",
                                icon: <Circle size={12}/>,
                                navLink: "/hse_models/commission_extra_fields",
                                meta: allow(G.SUPPORT, G.C_B2B, G.C_PM, G.C_PM_HSE, G.C_PROCURATOR_LEV1, G.C_PROCURATOR_LEV2)
                            },
                            {
                                id: "meeting_types",
                                title: "Meeting Types",
                                icon: <Circle size={12}/>,
                                navLink: '/meeting_types',
                                meta: allow(G.SUPPORT, G.C_B2B, G.C_PM, G.C_PM_HSE, G.C_PROCURATOR_LEV1, G.C_PROCURATOR_LEV2,)
                            },
                            {
                                id: "commissions_statuses",
                                title: "Status Commissions",
                                icon: <Circle size={12}/>,
                                navLink: '/commission_statuses',
                                meta: allow(G.SUPPORT, G.C_B2B, G.C_PM, G.C_PM_HSE, G.C_PROCURATOR_LEV1, G.C_PROCURATOR_LEV2)
                            },
                            {
                                id: "commission_flow_templates",
                                title: "Gantt Templates",
                                icon: <Circle size={12}/>,
                                navLink: '/commission_flow_templates',
                                meta: allow(G.SUPPORT, G.C_B2B, G.C_PM, G.C_PM_HSE, G.C_PROCURATOR_LEV1, G.C_PROCURATOR_LEV2)
                            },
                            {
                                id: "commission_models",
                                title: "Commission Models",
                                icon: <Circle size={12}/>,
                                navLink: "/hse_models/commission",
                                meta: allow(G.SUPPORT, G.C_B2B, G.C_PM, G.C_PM_HSE, G.C_PROCURATOR_LEV1, G.C_PROCURATOR_LEV2)
                            },
                            // Hide ODL Types management for the moment, DB-First
                            // {
                            //     id: "odl_types",
                            //     title: "ODL Types",
                            //     icon: <Circle size={12}/>,
                            //     navLink: '/odl_types',
                            //     meta: allow(...ADMIN_SETUP),
                            // },
                        ]
                    }
                ],
            },
            {
                id: "company231",
                title: "Companies231",
                icon: <Home size={20}/>,
                navLink: '/companies231',
                meta: allow(G.VALIDATOR_231, G.MANAGER_231)
            },
            {
                id: "performance",
                title: "Performance",
                icon: <TrendingUp size={20}/>,
                navLink: "/kpi_management",
                meta: allow(G.ADMIN, G.HSE_MGR, G.ACTIVITY_SUPERVISOR, G.SUPPORT, G.HSE_SUPERVISOR, G.Q_MANAGER),
                children: [
                    {
                        id: "dashboard_checkin",
                        title: "Dashboard CheckIn",
                        icon: <Circle size={12}/>,
                        navLink: "/dashboard_checkin",
                        meta: allow(...ADMIN_HSE)
                    },
                    {
                        id: "dashboard_hse_analytics",
                        title: "Report HSE Analytics",
                        icon: <Circle size={12}/>,
                        navLink: "/dashboard_hse_analytics",
                        meta: allow(...ADMIN_HSE)
                    },
                    {
                        id: "partner_evaluations",
                        title: "PartnerEvaluation.module_title",
                        icon: <Circle size={12}/>,
                        navLink: "/partner-evaluations",
                        meta: allow(...ADMIN_HSE, G.Q_MANAGER)
                    },
                    {
                        id: "kpi_management",
                        title: "Process",
                        icon: <Circle size={12}/>,
                        navLink: "/kpi_management",
                        meta: allow(G.ADMIN, G.ACTIVITY_SUPERVISOR, G.SUPPORT)
                    }
                ],
            },
            {
                id: "agenda",
                title: "Agenda",
                icon: <Calendar size={20}/>,
                navLink: "/agenda",
                meta: allow(G.PLANNER, G.ADMIN, G.HSE_MGR, G.ACTIVITY_SUPERVISOR, G.MANAGER, G.SUPPORT, G.HSE_SUPERVISOR)
            },
            {
                id: "activity-list",
                title: "Activity List",
                icon: <Activity size={12}/>,
                navLink: "/activities",
                meta: allow(G.PLANNER, G.ADMIN, G.BACKOFFICE, G.LOGISTICIAN, G.ACTIVITY_SUPERVISOR, G.MANAGER, G.SUPPORT)
            },
            {
                id: "maintenance-list",
                title: "Maintenances List",
                icon: <Tool size={12}/>,
                navLink: "/maintenances",
                meta: allow(G.PLANNER, G.ADMIN, G.BACKOFFICE, G.HSE_MGR, G.ACTIVITY_SUPERVISOR, G.MANAGER, G.SUPPORT, G.HSE_SUPERVISOR)
            },
            {
                id: "inspection-list",
                title: "Inspection List",
                icon: <Server size={12}/>,
                navLink: "/inspections",
                meta: allow(G.ADMIN, G.ACTIVITY_SUPERVISOR, G.SUPPORT, G.MANAGER, G.HSE_MGR, G.HSE_SUPERVISOR)
            },
            {
                id: "attendance",
                title: "Attendances",
                icon: <Clock size={20}/>,
                navLink: "/attendance",
                meta: allow(G.PLANNER, G.BACKOFFICE, G.SUPPORT)
            },
            {
                id: "configuration",
                title: "ConfigurationX",
                icon: <Settings size={20}/>,
                navLink: "/company_configuration",
                meta: allow(G.ADMIN, G.BACKOFFICE, G.SUPPORT),
                children: [
                    {
                        id: "company_configuration",
                        title: "Company",
                        icon: <Circle size={12}/>,
                        navLink: "/company_configuration",
                        meta: allow(G.ADMIN, G.BACKOFFICE, G.SUPPORT)
                    }
                ],
            },
            {
                id: "comunication_list",
                title: "Comunications",
                badge: 'primary',
                badgeText: '',
                comunicationBadge: true,
                icon: <Mail size={20}/>,
                navLink: "/comunications",
                meta: allow(ALL_PROFILES.filter(g => g !== G.TECHNICIAN))
            },
            {
                header: 'Training',
                meta: allow(...ADMIN_SUPPORT)
            },
            {
                id: "resources",
                title: "Play & Learn",
                icon: <Award size={20}/>,
                meta: allow(...ADMIN_SUPPORT),
                children: [
                    {
                        id: "courses",
                        title: "Courses",
                        icon: <Circle size={12}/>,
                        navLink: "/lms/courses",
                        meta: allow(...ADMIN_SUPPORT)
                    },
                    {
                        id: "quiz",
                        title: "Quiz",
                        icon: <Circle size={20}/>,
                        navLink: '/lms/quizzes',
                        meta: allow(...ADMIN_SUPPORT)
                    },
                    {
                        id: "challenges",
                        title: "Challenges",
                        icon: <Circle size={20}/>,
                        navLink: '/lms/challenges',
                        meta: allow(...ADMIN_SUPPORT)
                    },
                    {
                        id: "prizes",
                        title: "Prizes",
                        icon: <Circle size={20}/>,
                        navLink: '/lms/prizes',
                        meta: allow(...ADMIN_SUPPORT)
                    }
                ]
            },
            // ** Utility for accessing directly to enrollments ( NOT FOR ADMIN )
            // {
            //     id: "resources_learning",
            //     title: "Play & Learn",
            //     icon: <Award size={20}/>,
            //     navLink: '/lms/user/enrollments',
            //     meta: {
            //         publicRoute: false,
            //         administrator: false,
            //         technician: true,
            //         planner: true,
            //         "backoffice-manager": true,
            //         "commission-engineer": true,
            //         "commission-partner-coordinator": true,
            //         "hse-manager": true,
            //         logistician: true,
            //         "activity-supervisor": true,
            //         "manager": true,
            //         "validator-231": true,
            //         "manager-231": true,
            //         "mobile-worker": true,
            //         "commercial": true,
            //         "marketing": true,
            //         "support": true,
            //         "commission-pm": true,
            //         "hse-supervisor": true,
            //         "commission-b2b-coordinator": true,
            //         "commission-rl": true,
            //         "commission-csp": true,
            //         "commission-internal-permitting": true,
            //         "commission-external-permitting": true,
            //         "commission-cse": true,
            //         "commission-construction-manager": true,
            //         "commission-construction-assistant": true
            //     }
            // },
            {
                header: 'Registry',
                meta: allow(G.ADMIN, G.HSE_MGR, G.ACTIVITY_SUPERVISOR, G.SUPPORT, G.HSE_SUPERVISOR)
            },
            {
                id: "plants",
                title: "Plants",
                icon: <Home size={20}/>,
                navLink: '/plants',
                meta: allow(G.PLANNER, G.ADMIN, G.BACKOFFICE, G.HSE_MGR, G.ACTIVITY_SUPERVISOR, G.MANAGER, G.SUPPORT, G.HSE_SUPERVISOR)
            },
            {
                id: "customers",
                title: "Customers",
                icon: <AtSign size={20}/>,
                navLink: '/customers',
                meta: allow(G.ADMIN, G.ACTIVITY_SUPERVISOR)
            },
            {
                id: "groups",
                title: "Groups",
                icon: <Grid size={20}/>,
                navLink: '/groups',
                meta: allow(...ADMIN_SUPPORT),
                children: [
                    {
                        id: "maintenance_groups",
                        title: "Maintenance Groups",
                        icon: <Circle size={12}/>,
                        navLink: "/groups",
                        meta: allow(...ADMIN_SUPPORT)
                    },
                    {
                        id: "supervisor_groups",
                        title: "Supervisor Groups",
                        icon: <Circle size={12}/>,
                        navLink: "/supervisor_groups",
                        meta: allow(...ADMIN_SUPPORT)
                    }
                ],
            },
            {
                id: "contracts",
                title: "Contracts",
                icon: <Printer size={20}/>,
                navLink: '/contracts',
                meta: allow(G.ADMIN, G.HSE_MGR, G.ACTIVITY_SUPERVISOR, G.SUPPORT, G.HSE_SUPERVISOR)
            },
            {
                id: "processes",
                title: "Processes",
                icon: <Command size={20}/>,
                navLink: '/processes',
                meta: allow(...ADMIN_SUPPORT)
            },
            {
                id: "workorders",
                title: "Workorders",
                icon: <Folder size={20}/>,
                navLink: '/workorders',
                meta: allow(...ADMIN_SUPPORT)
            },
            {
                id: "company",
                title: "Companies",
                icon: <Briefcase size={20}/>,
                navLink: '/companies',
                meta: allow(G.ADMIN, G.BACKOFFICE, G.HSE_MGR, G.SUPPORT, G.HSE_SUPERVISOR, G.C_PROCURATOR_LEV1, G.C_PROCURATOR_LEV2, G.C_B2B, G.C_PM, G.C_PM_HSE)
            },

            {
                id: "partner_qualification",
                title: "Qualifica Partner",
                navLink: "",
                icon: <Clipboard size={20}/>,
                meta: allow(...PQ_ACCESS),
                children: [
                    {
                        id: "pq_iter",
                        title: "Iter di qualifica",
                        icon: <Circle size={12}/>,
                        navLink: "/partner-qualification/iter",
                        meta: allow(...PQ_ACCESS)
                    },
                    {
                        id: "pq_committees",
                        title: "Comitati di Accreditamento",
                        icon: <Circle size={12}/>,
                        navLink: "/partner-qualification/committees",
                        meta: allow(...PQ_ACCESS)
                    },
                    {
                        id: "pq_partners",
                        title: "Partner",
                        icon: <Circle size={12}/>,
                        navLink: "/partner-qualification/partners",
                        meta: allow(...PQ_ACCESS)
                    },
                    {
                        id: "pq_contracts",
                        title: "Contratti",
                        icon: <Circle size={12}/>,
                        navLink: "/partner-qualification/contracts",
                        meta: allow(...PQ_ACCESS)
                    },
                    {
                        id: "pq_settings",
                        title: "Configurazione",
                        navLink: "",
                        icon: <Circle size={12}/>,
                        meta: allow(...PQ_ADMIN),
                        children: [
                            {
                                id: "pq_natures",
                                title: "Nature",
                                icon: <Circle size={12}/>,
                                navLink: "/partner-qualification/settings/natures",
                                meta: allow(...PQ_ADMIN)
                            },
                            {
                                id: "pq_categories",
                                title: "Categorie",
                                icon: <Circle size={12}/>,
                                navLink: "/partner-qualification/settings/categories",
                                meta: allow(...PQ_ADMIN)
                            },
                            {
                                id: "pq_requirements",
                                title: "Requisiti",
                                icon: <Circle size={12}/>,
                                navLink: "/partner-qualification/settings/requirements",
                                meta: allow(...PQ_ADMIN)
                            },
                            {
                                id: "pq_due_diligence_type",
                                title: "Tipologia due diligence",
                                icon: <Circle size={12}/>,
                                navLink: "/partner-qualification/settings/due-diligence-type",
                                meta: allow(...PQ_ADMIN)
                            },
                            {
                                id: "pq_questionnaires",
                                title: "Questionari",
                                icon: <Circle size={12}/>,
                                navLink: "/partner-qualification/settings/questionnaires",
                                meta: allow(...PQ_ADMIN)
                            },
                            {
                                id: "pq_document_templates",
                                title: "Template documenti",
                                icon: <Circle size={12}/>,
                                navLink: "/partner-qualification/settings/document-templates",
                                meta: allow(...PQ_ADMIN)
                            },
                        ],
                    },
                ],
            },
            {
                id: "hse_docs",
                title: "Models",
                icon: <File size={20}/>,
                navLink: '/hse_doc',
                // Q_MANAGER sees the group only for the evaluation type catalog (child with PQ_ADMIN)
                meta: allow(...ADMIN_HSE, G.Q_MANAGER),
                children: [
                    {
                        id: "user_hse_models",
                        title: "User HSE Models",
                        icon: <Circle size={12}/>,
                        navLink: "/hse_models/user",
                        meta: allow(...ADMIN_HSE)
                    },
                    {
                        id: "company_hse_models",
                        title: "Company HSE Models",
                        icon: <Circle size={12}/>,
                        navLink: "/hse_models/company",
                        meta: allow(...ADMIN_HSE)
                    },
                    {
                        id: "equipment_hse_models",
                        title: "Equipment HSE Models",
                        icon: <Circle size={12}/>,
                        navLink: "/hse_models/equipment_hse_models",
                        meta: allow(...ADMIN_HSE)
                    },
                    {
                        id: "hse_roles",
                        title: "Hse Roles",
                        icon: <Circle size={12}/>,
                        navLink: "/hse_models/hse_roles",
                        meta: allow(...ADMIN_HSE)
                    },
                    {
                        id: "maintenances_types",
                        title: "User Maintenance Types",
                        icon: <Circle size={12}/>,
                        navLink: "/hse_models/user_maintenance_types",
                        meta: allow(...ADMIN_HSE)
                    },
                    {
                        id: "company_legal_forms",
                        title: "Company Legal Forms",
                        icon: <Circle size={12}/>,
                        navLink: "/hse_models/company_legal_forms",
                        meta: allow(...ADMIN_HSE)
                    },
                    {
                        id: "base_packages",
                        title: "Base Packages",
                        icon: <Circle size={12}/>,
                        navLink: "/hse_models/base_packages",
                        meta: allow(...ADMIN_HSE)
                    },
                    {
                        id: "equipment_types",
                        title: "Equipment Types",
                        icon: <Circle size={12}/>,
                        navLink: "/hse_models/equipment_types",
                        meta: allow(...ADMIN_HSE)
                    },
                    {
                        id: "partner_evaluation_types",
                        title: "PartnerEvaluationType.module_title",
                        icon: <Circle size={12}/>,
                        navLink: "/partner-evaluations/settings/types",
                        meta: allow(...PQ_ADMIN, G.HSE_MGR, G.HSE_SUPERVISOR)
                    }
                ],
            },
            {
                id: "users",
                title: "Users",
                icon: <User size={20}/>,
                navLink: '/users',
                meta: allow(G.ADMIN, G.BACKOFFICE, G.HSE_MGR, G.SUPPORT, G.HSE_SUPERVISOR, G.C_PROCURATOR_LEV1, G.C_PROCURATOR_LEV2, G.C_B2B, G.C_PM, G.C_PM_HSE)
            },
            {
                id: "comunication_groups",
                title: "Comunication Groups",
                icon: <Users size={12}/>,
                navLink: "/comunication_groups",
                meta: allow(...ADMIN_HSE)
            },
            {
                id: "comunication_types",
                title: "Comunication Types",
                icon: <Archive size={12}/>,
                navLink: "/comunication_types",
                meta: allow(...ADMIN_HSE)
            },
            {
                id: "report_types",
                title: "Report Types",
                icon: <Layout size={20}/>,
                navLink: '/report_types',
                meta: allow(...ADMIN_SUPPORT)
            },
            {
                id: "proposal",
                title: "Proposals",
                icon: <Copy size={20}/>,
                navLink: '/proposals',
                meta: allow(G.ADMIN, G.DATA_ANALYST, G.MOBILE_WORKER, G.COMMERCIAL, G.MARKETING, G.SUPPORT)
            },
            {
                header: 'Support',
                meta: allow(ALL_PROFILES.filter(g => ![G.TECHNICIAN].includes(g)))
            },
            {
                // Olympus-FE will search for this ID and remove the href and attach the event handler for appInfo.appWikiUrl if available
                // If not, the navLink will be triggered and forwarded to its page.
                id: "userGuideButton",
                title: "Guide",
                icon: <Book size={20}/>,
                navLink: '/guida',
                meta: allow(ALL_PROFILES.filter(g => ![G.TECHNICIAN, G.Q_MANAGER, G.Q_OPERATOR, G.Q_DD_VALIDATOR, G.DATA_ANALYST].includes(g)))
            },
            {
                // Olympus-FE will search for this ID and remove the href and attach the event handler for appInfo.appSupportUrl if available
                // If not, the navLink will be triggered and forwarded to its page.
                id: "userSupportButton",
                title: "Support",
                icon: <HelpCircle size={20}/>,
                navLink: '/support',
                meta: allow(ALL_PROFILES.filter(g => ![G.TECHNICIAN].includes(g)))
            },
            {
                id: "helpCenterButton",
                title: "Help Center",
                icon: <BookOpen size={20}/>,
                navLink: '/help-center',
                meta: allow(ALL_PROFILES.filter(g => ![G.TECHNICIAN].includes(g)))
            }
        ],
        scrollTop: true, // Enable scroll to top button
    }
}
